import React from 'react';
import './DrawerHeaderTitleCustom.scss';
import { Text } from '@fluentui/react-components';
import { CircleArrowOutUpRight, X } from 'lucide-react';
import SyButton from './SyButton';
import { DocumentIcon } from './DocumentIcon';
import SpinnerOverlay from './SpinnerOverlay';

interface Props {
  title?: string;
  onOpen?: () => void;
  onClose?: () => void;
  isLoading?: boolean;
  openLabel?: string;
}

export const DrawerHeaderTitleCustom: React.FC<Props> = ({ title, onOpen, onClose, isLoading = false, openLabel = 'Open document' }) => {
  return (
    <div className="drawer-header-custom" role="banner">
      <div className="drawer-header-left">
        <DocumentIcon className="drawer-header-book-icon" />
        <Text weight="semibold" className="drawer-header-title">{title}</Text>
      </div>
      <div className="drawer-header-actions">
        <SpinnerOverlay isLoading={isLoading}>
          <SyButton className="open-btn" appearance="primary" size="small" icon={<CircleArrowOutUpRight className="open-lucide-icon" strokeWidth={2} size={14} />} onClick={onOpen}>{openLabel}</SyButton>
        </SpinnerOverlay>
        <button className="drawer-header-close" aria-label="Close" title="Close" onClick={onClose}>
          <X size={20} />
        </button>
      </div>
    </div>
  );
};

export default DrawerHeaderTitleCustom;
